// Sign-up guard against subscription-bombing bots (Paul, 2 Oct 2026). Bots sign a victim's Gmail up everywhere with dots
// sprinkled through it (Gmail ignores dots, so every variant reaches the same inbox), or a phone's SMS-gateway address.
// A real person with a dotted Gmail just types it without the dots - it still reaches them. KEEP IN STEP with
// looksLikeBombBot in scripts/_mailing-list-sync.js and blockBombSignups in the backend (yearly-upgrade/functions).
const SMS_GATEWAYS = /@(tmomail\.net|vtext\.com|vzwpix\.com|txt\.att\.net|mms\.att\.net|messaging\.sprintpcs\.com|pm\.sprint\.com|msg\.fi\.google\.com|sms\.\w+)$/i;

/** A message to show instead of creating the account, or null when the address is fine. */
export function signupBlockReason(email) {
  const e = String(email || "").trim().toLowerCase();
  if (SMS_GATEWAYS.test(e)) return "Please sign up with an email address rather than a phone text-message address.";
  const [local, domain] = e.split("@");
  if ((domain === "gmail.com" || domain === "googlemail.com") && (local.match(/\./g) || []).length >= 3) {
    return "Please type your Gmail address without the dots in the part before the @ (Gmail ignores them, so your email will still reach you).";
  }
  return null;
}
